<!--系统管理页面弹窗组件  :rules="rules"-->
<template>
    <el-dialog
        title="服务项目"
        :visible="show"
        width="40%"
        :before-close="closeWindow"
        append-to-body
    >
        <div class="cu-title1">
            <div class="cu-title2">
                <div>项目名称</div>
                <el-input
                    size="medium"
                    v-model="form1.serviceProductName"
                ></el-input>
            </div>
            <div class="cu-title3">
                <el-button type="primary" size="medium" @click="getDataList"
                    >查询</el-button
                >
            </div>
        </div>
        <div style="margin: 20px 0">
            <el-table
                @selection-change="handleSelectionChange"
                border
                class="form-table"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                ref="multipleTable"
            >
                <el-table-column
                    align="center"
                    fixed
                    type="index"
                    label="序号"
                    width="50"
                >
                </el-table-column>
                <el-table-column align="center" type="selection" width="55">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="serviceProductName"
                    label="名称"
                    show-overflow-tooltip
                >
                </el-table-column>
                <!--        <el-table-column align="center" prop="produce" label="产品说明" show-overflow-tooltip>-->
                <!--        </el-table-column>-->
                <!--        <el-table-column align="center" prop="referTime" show-overflow-tooltip label="参考工时">-->
                <!--        </el-table-column>-->
                <!--        <el-table-column align="center" prop="price" show-overflow-tooltip label="参考价格">-->
                <!--        </el-table-column>-->
                <!--        <el-table-column align="center" prop="firstName" show-overflow-tooltip label="类型一">-->
                <!--        </el-table-column>-->
                <!--        <el-table-column align="center" prop="secondName" show-overflow-tooltip label="类型二">-->
                <!--        </el-table-column>-->
            </el-table>
        </div>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
        </div>
        <div
            style="
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 15px;
            "
        >
            <el-button type="primary" @click="send">保存</el-button>
            <el-button @click="closeWindow">取 消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import request from "@/utils/request.js"

export default {
    name: "CustomerList",
    props: {
        serviceNumber: {
            type: Number,
            default: 0,
        },
        serviceTypeId: {
            default: "",
        },
        showChanpin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form1: {},
            tableData: [],
            query: {
                pageNo: 1,
                pageSize: 5,
            },
            totalCount: 0,
            productData: [],
        }
    },
    computed: {
        show() {
            return this.showChanpin
        },
    },
    methods: {
        handleSelectionChange(val) {
            if (val) {
                this.productData = val
            }
        },
        getDataList() {
            let params = {
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                serviceTypeId: this.serviceTypeId,
                serviceProductName: this.form1.serviceProductName,
            }
            request({
                url: "/jjyl/admin/product/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code === 200 && res.content) {
                    this.tableData = res.content.list || []
                    this.totalCount = res.content.count || 0
                }
            })
        },
        handleSizeChange(val) {
            this.query.pageSize = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.getDataList()
        },
        send() {
            if (this.serviceNumber === 0) {
                this.$message.error(`请选择套餐类型`)
                return
            }
            if (this.productData.length !== this.serviceNumber) {
                this.$message.error(
                    `请选择${this.serviceNumber}个服务,当前选择${this.productData.length}个`
                )
                return
            }
            this.$emit("send", JSON.parse(JSON.stringify(this.productData)))
            this.closeWindow()
        },
        closeWindow() {
            this.$emit("update:showChanpin", false)
            this.form1 = {}
            this.tableData = []
            this.query = {
                pageNo: 1,
                pageSize: 5,
            }
            // serviceProductName
            this.totalCount = 0
            this.productData = []
        },
        isFreeFormat(row, column) {
            if (row.isFree === "0") {
                return "否"
            } else if (row.isFree === "1") {
                return "是"
            }
        },
        typeFormat(row, column) {
            if (row.type === 7) {
                return "商业客户"
            } else if (row.type === 6) {
                return "民政客户"
            } else if (row.type === 4) {
                return "老干客户"
            } else if (row.type === 3) {
                return "残联客户"
            }
        },
    },
}
</script>
<style lang="less" scoped>
.cu-title1 {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
}

.cu-title1 > div {
    width: 50%;
}

.cu-title2 {
    display: flex;
    align-items: center;
}

.cu-title2 > div:first-child {
    width: 80px;
    text-align: center;
}

.cu-title2 > div:nth-child(2) {
    width: calc(100% - 80px);
}

.cu-title3 {
    margin-left: 30px;
}
</style>
